import { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

type AuthState = "checking" | "authed" | "guest";

export function ProtectedLayout() {
  const [auth, setAuth] = useState<AuthState>("checking");
  const navigate = useNavigate();
  const location = useLocation();

  const probe = useCallback(async () => {
    setAuth("checking");
    try {
      const res = await fetch("/api/decisions", { credentials: "include" });
      if (res.ok) {
        setAuth("authed");
        return;
      }
    } catch {
      /* fallthrough */
    }
    setAuth("guest");
  }, []);

  useEffect(() => {
    void probe();
  }, [probe]);

  useEffect(() => {
    if (auth === "guest") {
      navigate("/login", { replace: true, state: { from: location.pathname } });
    }
  }, [auth, location.pathname, navigate]);

  if (auth === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground" data-testid="auth-checking">
        Loading…
      </div>
    );
  }

  if (auth === "guest") {
    return null;
  }

  return <Outlet />;
}
